import { zodResolver } from '@mantine/form';

import { PaymentType } from '~/common/enums/payments.enum';

import type { FormValues } from '../context/withdrawal.context';
import { useWithdrawalForm } from '../context/withdrawal.context';

import useWithdrawalSchema from './useWithdrawalSchema';

const useWithdrawalFormInitialization = (
  useInitialValues = true,
  initialValues?: Partial<FormValues>
) => {
  const withdrawalSchema = useWithdrawalSchema();

  const form = useWithdrawalForm({
    initialValues: {
      mode: 'withdrawal', // Set default mode to prevent undefined state
      paymentType: useInitialValues ? PaymentType.CARD : null,
      withdrawalAmount: 0,
      ...initialValues,
    },
    validate: zodResolver(withdrawalSchema),
    validateInputOnBlur: true,
  });

  return form;
};

export default useWithdrawalFormInitialization;
